import { Navigate } from "react-router-dom";

export default function Login(props) {
    return <Navigate to="/" replace />;
};